/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ServicePropertiesAndServiceAreaDescription } from "./ServicePropertiesAndServiceAreaDescription";
import {
  ServicePropertiesAndServiceAreaDescriptionFromJSON,
  ServicePropertiesAndServiceAreaDescriptionFromJSONTyped,
  ServicePropertiesAndServiceAreaDescriptionToJSON,
  ServicePropertiesAndServiceAreaDescriptionToJSONTyped,
} from "./ServicePropertiesAndServiceAreaDescription";

/**
 *
 * @export
 * @interface CarrierInfoResponseService
 */
export interface CarrierInfoResponseService {
  /**
   *
   * @type {string}
   * @memberof CarrierInfoResponseService
   */
  serviceIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierInfoResponseService
   */
  customerServiceName: string;
  /**
   *
   * @type {ServicePropertiesAndServiceAreaDescription}
   * @memberof CarrierInfoResponseService
   */
  serviceProperties: ServicePropertiesAndServiceAreaDescription;
  /**
   *
   * @type {string}
   * @memberof CarrierInfoResponseService
   */
  accountNumbers: string;
}

/**
 * Check if a given object implements the CarrierInfoResponseService interface.
 */
export function instanceOfCarrierInfoResponseService(
  value: object,
): value is CarrierInfoResponseService {
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (
    !("customerServiceName" in value) ||
    value["customerServiceName"] === undefined
  )
    return false;
  if (
    !("serviceProperties" in value) ||
    value["serviceProperties"] === undefined
  )
    return false;
  if (!("accountNumbers" in value) || value["accountNumbers"] === undefined)
    return false;
  return true;
}

export function CarrierInfoResponseServiceFromJSON(
  json: any,
): CarrierInfoResponseService {
  return CarrierInfoResponseServiceFromJSONTyped(json, false);
}

export function CarrierInfoResponseServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInfoResponseService {
  if (json == null) {
    return json;
  }
  return {
    serviceIdentifier: json["serviceIdentifier"],
    customerServiceName: json["customerServiceName"],
    serviceProperties: ServicePropertiesAndServiceAreaDescriptionFromJSON(
      json["serviceProperties"],
    ),
    accountNumbers: json["accountNumbers"],
  };
}

export function CarrierInfoResponseServiceToJSON(
  json: any,
): CarrierInfoResponseService {
  return CarrierInfoResponseServiceToJSONTyped(json, false);
}

export function CarrierInfoResponseServiceToJSONTyped(
  value?: CarrierInfoResponseService | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    serviceIdentifier: value["serviceIdentifier"],
    customerServiceName: value["customerServiceName"],
    serviceProperties: ServicePropertiesAndServiceAreaDescriptionToJSON(
      value["serviceProperties"],
    ),
    accountNumbers: value["accountNumbers"],
  };
}
